import React from 'react';
import { useDispatch } from 'react-redux';
import ExportButtonWithLoader from '@/Framework/UI/Atoms/Button/ExportButtonWithLoader';
import metadataSelectors from '@/finsight/application/actions/bonds/metadata/selectors';
import { exportToExcel } from '@/finsight/application/actions/bonds/metadata/actions';
import useReduxSelector from '@/Framework/hooks/useReduxSelector';
import { useFiltersContext } from '@/finsight/application/FiltersContext';
import { useInventoryTableContext } from '@/finsight/application/Bonds/InventoryTableContext';
import { useBwicTableContext } from '@/finsight/application/Bonds/BwicTableContext';

const stateSelector = (state) => ({
  isFetching: metadataSelectors.isExportFetching(state),
});

const BondTypesContainer = (props) => {
  const dispatch = useDispatch();
  const { isFetching } = useReduxSelector(stateSelector);
  const {
    inventoriesData: { inventories: { totalCount: inventoriesTotalCount } },
  } = useInventoryTableContext();
  const {
    bwicsData: { bwics: { totalCount: bwicsTotalCount } },
  } = useBwicTableContext();
  const { params: { search } } = useFiltersContext();

  return (
    <ExportButtonWithLoader
      { ...props }
      isFetching={ isFetching }
      isDisabled={ !(inventoriesTotalCount || bwicsTotalCount) }
      onClick={ () => dispatch(exportToExcel({ assetClassId: undefined, search })) }
    />
  );
};

export default BondTypesContainer;
